export default "__VITE_ASSET__7136c85c__"